var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"vx-col w-full mb-1 mt-2"},[_vm._m(0),_c('vs-divider')],1)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('p',[_c('strong',[_vm._v("Datos de la dirección de su empleo:")])])}]

export { render, staticRenderFns }